import { useMutation } from '@tanstack/react-query';
import { SURVEY_DEFAULT_VALUES, SURVEY_FIELDS } from '../../survey-questions';
import { useAccessToken } from '../useProfile';

interface SurveyResponse {
  question: string;
  answer: string | number | boolean;
}

type UseSubmitIntakeOptions = {
  onMutate?: () => void;
  onSuccess?: () => void;
  onError?: (error: Error) => void;
};

export const useSubmitIntake = ({
  onMutate,
  onSuccess,
  onError,
}: UseSubmitIntakeOptions = {}) => {
  const { data: accessToken } = useAccessToken();

  return useMutation({
    mutationFn: async (value: typeof SURVEY_DEFAULT_VALUES) => {
      const surveyResponses: SurveyResponse[] = SURVEY_FIELDS.map((field) => ({
        question: field.question,
        answer: value[field.name as keyof typeof value] || '',
      }));

      const response = await fetch(
        `${import.meta.env.REACT_APP_API_SERVICE_URI}/api/intake/submit`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify({ surveyResponses, raw: value }),
        },
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to submit form');
      }
    },
    onMutate,
    onSuccess,
    onError,
  });
};
